import { api, ensureCsrf, resetCsrf } from './client';

/** Helper: backend returns either {user} or {data} for the current user. */
function unwrapUser(payload) {
  return payload?.user ?? payload?.data ?? payload ?? null;
}

/**
 * POST /api/login — credentials are { username, password, remember?, device_name? }.
 * Email is NOT accepted as a login credential. 422 failures carry the
 * user-facing copy under `errors.username[0]` (normalized by the client
 * interceptor onto `err.errors.username`).
 */
export async function login(credentials) {
  await ensureCsrf();
  const { data } = await api.post('/login', credentials);
  return unwrapUser(data);
}

export async function logout() {
  try {
    await api.post('/logout');
  } finally {
    resetCsrf();
  }
}

export async function me() {
  const { data } = await api.get('/me');
  return unwrapUser(data);
}

export async function forgotPassword(email) {
  await ensureCsrf();
  const { data } = await api.post('/forgot-password', { email });
  return data;
}

export async function resetPassword(payload) {
  await ensureCsrf();
  const { data } = await api.post('/reset-password', payload);
  return data;
}

export async function changePassword(payload) {
  const { data } = await api.post('/change-password', payload);
  return data;
}
